import { render, staticRenderFns } from "./UnwantedEffectsBlock.vue?vue&type=template&id=62765f7a&lang=pug&"
import script from "./UnwantedEffectsBlock.vue?vue&type=script&lang=js&"
export * from "./UnwantedEffectsBlock.vue?vue&type=script&lang=js&"
import style0 from "./UnwantedEffectsBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports